import { render, staticRenderFns } from "./usappbkchargehandver.vue?vue&type=template&id=6fbb93b4&scoped=true&"
import script from "./usappbkchargehandver.vue?vue&type=script&lang=js&"
export * from "./usappbkchargehandver.vue?vue&type=script&lang=js&"
import style0 from "./usappbkchargehandver.vue?vue&type=style&index=0&id=6fbb93b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbb93b4",
  null
  
)

export default component.exports